import { ImageElementDto } from "@repo/api/overlays";
import { Img } from "remotion";
import { getMediaSrc } from "../../utils/media.ts";
import { AssetMediaAsyncDto } from "@repo/api/asset-media";

type Props = {
  element: ImageElementDto;
  assetMedias: Record<string, AssetMediaAsyncDto>;
};

export default function ImageElement({ element, assetMedias }: Props) {
  const assetMedia = assetMedias[element.assetMediaExternalId];

  if (!assetMedia || assetMedia.status !== "COMPLETED") {
    return null;
  }

  return (
    <Img
      src={getMediaSrc(assetMedia.data.src)}
      className="h-full w-full object-cover object-top-left"
    />
  );
}
